import { useMutation } from "urql";

import { CreatePengurusDocument } from "../../../../graphql/generated.ts";

export function useCreatePengurus() {
  return useMutation(CreatePengurusDocument);
}
